// @flow
import * as React from 'react';
import styled from 'styled-components';
import Image, {BackgroundImage} from 'components/Image';
import {LayoutColumn, LayoutInline} from 'components/Layout';
import {
  LocalizedParagraph,
  useLocalized,
} from 'components/Localized';
import ButtonNextPage from 'components/ButtonNextPage';

type Props = {
  items: Array<boolean>,
  ecoItemCount: number,
  completed: boolean,
  onRetry: () => void,
  onNext: () => void,
  onEcoDisclaimer: () => void,
  isHidden: boolean,
};

export default function DrivingResult(props: Props): React.Element<any> {
  const localized = useLocalized();

  return (
    <Wrapper isHidden={props.isHidden}>
      {props.completed === true && (
        <WrapperTopCompleted>
          <LayoutCenter>
            <LocalizedParagraph {...localized.driving_a02_result_002} />
            <LocalizedParagraph {...localized.driving_a02_result_004} />
          </LayoutCenter>
        </WrapperTopCompleted>
      )}
      {props.completed !== true && (
        <WrapperTopTryAgain>
          <LayoutCenter>
            <LocalizedParagraph {...localized.driving_a02_result_001} />
            <LocalizedParagraph {...localized.driving_a02_result_003} />
          </LayoutCenter>
        </WrapperTopTryAgain>
      )}
      <WrapperItems>
        <div>
        <div>
          <BackgroundImage source={props.items?.[0] === true ? "./driving-zone/img-item-bg-on.png" : "./driving-zone/img-item-bg-off.png"}>
            <Image1 source="./driving-zone/result-img-item-1-ic.png" />
          </BackgroundImage>
          <LocalizedParagraph {...localized.driving_a02_result_010} />
        </div>
        <div>
          <BackgroundImage source={props.items?.[1] === true ? "./driving-zone/img-item-bg-on.png" : "./driving-zone/img-item-bg-off.png"}>
            <Image2 source="./driving-zone/result-img-item-2-ic.png" />
          </BackgroundImage>
          <LocalizedParagraph {...localized.driving_a02_result_011} />
        </div>
        <div>
          <BackgroundImage source={props.items?.[2] === true ? "./driving-zone/img-item-bg-on.png" : "./driving-zone/img-item-bg-off.png"}>
            <Image3 source="./driving-zone/result-img-item-3-ic.png" />
          </BackgroundImage>
          <LocalizedParagraph {...localized.driving_a02_result_012} />
        </div>
        <div>
          <BackgroundImage source={props.items?.[3] === true ? "./driving-zone/img-item-bg-on.png" : "./driving-zone/img-item-bg-off.png"}>
            <Image4 source="./driving-zone/result-img-item-4-ic.png" />
          </BackgroundImage>
          <LocalizedParagraph {...localized.driving_a02_result_013} />
        </div>

        <button onClick={()=>{
          const resultECOText = document.getElementById("resultECOText");
          if (resultECOText != null) {
            console.log(resultECOText.innerText);
            if (resultECOText.innerText.indexOf("ⓘ") < 0) {
              return;
            }
          }
          props.onEcoDisclaimer();
        }} >
        <div>

          <BackgroundImage source={Math.min(100, Math.floor(props.ecoItemCount * 0.91)) >= 100 ? "./driving-zone/img-item-bg-on.png" : "./driving-zone/img-item-bg-off.png"}>
            <Image5 source="./driving-zone/result-img-item-5-ic.png" />
          </BackgroundImage>
          <LocalizedParagraph id="resultECOText" {...localized.driving_a02_result_014} />
        </div>
        </button>
        </div>
      </WrapperItems>
      <div />
      <ButtonNextPage buttons={[{onNext: props.onRetry, title:localized.driving_a02_result_005, dataBackground:"#05141f", dataOutline:"#ffffff"}, {onNext: props.onNext, title: localized.driving_a02_result_006}]} />
    </Wrapper>
  );
}

const Image1 = styled(Image)`
    width: ${(props) => (props.theme.layout.mobile ? 35 : 60)}px;
    height: ${(props) => (props.theme.layout.mobile ? 35 : 60)}px;
`;

const Image2 = styled(Image)`
    width: ${(props) => (props.theme.layout.mobile ? 31 : 54)}px;
    height: ${(props) => (props.theme.layout.mobile ? 22 : 38)}px;
`;
const Image3 = styled(Image)`
    width: ${(props) => (props.theme.layout.mobile ? 35 : 60)}px;
    height: ${(props) => (props.theme.layout.mobile ? 34 : 58)}px;
`;
const Image4 = styled(Image)`
    width: ${(props) => (props.theme.layout.mobile ? 25 : 40)}px;
    height: ${(props) => (props.theme.layout.mobile ? 35 : 56)}px;
`;
const Image5 = styled(Image)`
    width: ${(props) => (props.theme.layout.mobile ? 35 : 57)}px;
    height: ${(props) => (props.theme.layout.mobile ? 31 : 50)}px;
`;

const Wrapper = styled(LayoutColumn)`
  width: 100%;
  height: 100%;
  opacity: ${props => props.isHidden ? 0 : 1};
  >:nth-child(1) {
    flex: 1;
  }
  >:nth-child(3) {
    flex: 1;
  }
`;

const WrapperTopTryAgain = styled.div`
  margin-top: ${(props) => (props.theme.layout.mobile ? 26 : 31)}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    > :nth-child(2) {
      padding-top: ${(props) => (props.theme.layout.mobile ? 13 : 16)}px;
      display: block;
    }
  }
`;
const WrapperTopCompleted = styled.div`
  width: 100%;
  height: ${(props) =>
    props.theme.layout.mobile ? 114 * (props.theme.layout.scale ?? 1) : 283 - 39}px;
  padding-top: ${(props) => (props.theme.layout.mobile ? 26 : 39)}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    > :nth-child(2) {
      padding-top: ${(props) => (props.theme.layout.mobile ? 13 : 21)}px;
      display: block;
    }
  }
`;
const WrapperItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 14px;
  pointer-events: auto;

  div {
    pointer-events: auto;

    width: ${(props) => (props.theme.layout.mobile ? 440 : 835)}px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    div {
      width: ${(props) => (props.theme.layout.mobile ? 80 : 130)}px;
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: start;

      div {
        height: ${(props) => (props.theme.layout.mobile ? 80 : 130)}px;
        margin-bottom: 10px;
        background-size: cover;
        background-repeat: no-repeat;
        display:flex;
        justify-content: center;
        align-items: center;

        img {
        }
      }

      p {
        display: inline;
        white-space: pre-wrap;
        width: ${(props) => (props.theme.layout.mobile ? 80 : 130)}px;
      }

    }
  }
`;
const LayoutCenter = styled(LayoutInline)`
  text-align: center;
`;
